import { QueryStore } from '../runtime/stores/query'
import artifact from '$houdini/artifacts/InventoryChangeLog'
import { initClient } from '$houdini/plugins/houdini-svelte/runtime/client'

export class InventoryChangeLogStore extends QueryStore {
	constructor() {
		super({
			artifact,
			storeName: "InventoryChangeLogStore",
			variables: true,
		})
	}
}

export async function load_InventoryChangeLog(params) {
  await initClient()

	const store = new InventoryChangeLogStore()

	await store.fetch(params)

	return {
		InventoryChangeLog: store,
	}
}
